<div class="flex w-full flex-auto justify-around gap-8">
  @for (_ of items(); track $index; let i = $index) {
    <input
      #input
      class="code-input bg-white"
      type="text"
      [placeholder]="placeholder()"
      [disabled]="isDisabled()"
      (keydown)="onKeydown($event, i)"
      (input)="onInput($event, i)"
      (paste)="onPaste($event, i)"
      (focus)="onFocus()"
      maxlength="1"
      autocomplete="off"
      autocorrect="off"
      autocapitalize="off"
      spellcheck="false"
    />
  }
</div>
